module.exports = __webpack_public_path__ + "img/pethouse20.965e7f72.jpg";